import React from "react";

export default function Terms({ onBack }) {
  return (
    <div className="terms-page">
      <div className="terms-header">
        {onBack && <button className="btn-back" onClick={onBack}>← Back</button>}
        <div className="terms-title">Terms & Conditions</div>
      </div>
      <div className="terms-content">

        <div className="terms-section">
          <div className="terms-section-title">Company Information</div>
          <p>Troy Trade Investment is a brand operated by <strong>PT. Artemis Bosphora Arthagena</strong>, a company incorporated under registration number <strong>8426105-4</strong>, with its registered office at House of Francis, Room 302, Ile Du Port, Mahe, Seychelles, authorized and regulated by the Cyprus Securities and Exchange Commission under CIF license number <strong>HE433420</strong>.</p>
        </div>

        <div className="terms-section">
          <div className="terms-section-title">Risk Warning</div>
          <p>Engaging in trading leveraged products such as Forex, CFDs, and derivatives entails significant risk to your capital and may not be appropriate for every investor. The value of investments can go down as well as up, and you may lose more than your initial investment.</p>
          <p>Before you trade, make sure you fully comprehend the risks involved, considering your investment objectives, level of experience, and risk appetite. Do not invest money you cannot afford to lose.</p>
        </div>

        <div className="terms-section">
          <div className="terms-section-title">Regional Restrictions</div>
          <p>PT. Artemis Bosphora Arthagena / Troy Trade Investment does not offer its services to residents of certain jurisdictions where such distribution would be contrary to local laws and regulations. It is the responsibility of the user to ensure that their use of our services complies with their local laws.</p>
        </div>

        <div className="terms-section">
          <div className="terms-section-title">No Financial Advice</div>
          <p>PT. Artemis Bosphora Arthagena / Troy Trade Investment does not issue advice, recommendations, or opinions in relation to acquiring, holding, or disposing of any financial product. All services are provided on an execution-only basis. Past performance does not constitute a reliable indicator of future results.</p>
        </div>

        <div className="terms-section">
          <div className="terms-section-title">Deposits & Withdrawals</div>
          <p>All deposits are processed through secure payment channels. Withdrawals are subject to verification and may take 1-5 business days to process. PT. Artemis Bosphora Arthagena reserves the right to request identity verification documents before processing any withdrawal.</p>
        </div>

        <div className="terms-section">
          <div className="terms-section-title">Contact Information</div>
          <p>Email: <a href="mailto:ptartemisbosphoraarthagena@gmail.com" style={{color:"#F0A500"}}>ptartemisbosphoraarthagena@gmail.com</a></p>
          <p>Website: <a href="http://artemisbosphora.com" target="_blank" rel="noreferrer" style={{color:"#F0A500"}}>artemisbosphora.com</a></p>
          <p>Address: House of Francis, Room 302, Ile Du Port, Mahe, Seychelles</p>
        </div>

        <div className="terms-risk-box">
          <strong>⚠️ Risk Warning:</strong> Trading leveraged products carries a high level of risk and may not be suitable for all investors. You could lose more than your initial investment. Please ensure you fully understand the risks involved.
        </div>

      </div>
    </div>
  );
}